module.exports = "/packs/check-white-3eb4a597ba68c604a66cb68638aeb5df.svg";